import { ProgressBar } from "primereact/progressbar";
import { pillars } from "./ZeroTrust";
import PhaseElement from "./ZeroTrustPhaseElement";

export default function PillarElement(props:any){

    const p = pillars.find((obj:any) => obj.id === props.pdata.id)
    const value = props.actions.metrics.pillars?.[props.pdata.id] * 100 || 0;
    return(
        <div className='pillar-container' style={{backgroundColor: p.color}}>
            <div className='col-2 flex d-flex flex-column' style={{justifyContent: 'center', alignItems: 'center'}}>
                <h5>{props.pdata.name}</h5>
                <ProgressBar value={value} color='green' style={{width: '100%'}}/>
            </div>
            {props.actions.phases.map((phase:any) => {
                return(
                    <PhaseElement key={`phase-${phase}`} p={props.pdata.id} phase={phase} dispatch={props.dispatch} actions={props.actions}/>
                )
            })}
        </div>
    )
}